import styled, { css } from "styled-components";

import colors from "core/colors";

// styled-components
export const UploadImageStyled = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
`;

export const ImageStyled = styled.img`
    /* center absolutely positioned asset */
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    /* resize asset so longest side spans parent container */
    max-height: 100%;
    max-width: 100%;

    background-color: ${colors.primary.whisker};

    ${({ imageIsBlurred }) =>
        imageIsBlurred &&
        css`
            filter: blur(15px);
        `};
`;
